var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgComment = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_728_27625)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.7999 12.6668L6.66657 15.0002L8.53324 12.6668H11.9999C12.1767 12.6668 12.3463 12.5966 12.4713 12.4716C12.5963 12.3465 12.6666 12.177 12.6666 12.0002V4.7355C12.6666 4.55869 12.5963 4.38912 12.4713 4.26409C12.3463 4.13907 12.1767 4.06883 11.9999 4.06883H1.33324C1.15643 4.06883 0.986856 4.13907 0.861833 4.26409C0.736808 4.38912 0.666571 4.55869 0.666571 4.7355V12.0002C0.666571 12.177 0.736808 12.3465 0.861833 12.4716C0.986856 12.5966 1.15643 12.6668 1.33324 12.6668H4.7999ZM14.6666 1.3335H3.33324V2.66683H13.9999V10.0002H15.3332V2.00016C15.3332 1.82335 15.263 1.65378 15.138 1.52876C15.013 1.40373 14.8434 1.3335 14.6666 1.3335Z",
    fill: "#6C7E8E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.33324,
    y: 6.6665,
    width: 6.66667,
    height: 1.33333,
    fill: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.33324,
    y: 8.6665,
    width: 4,
    height: 1.33333,
    fill: "#FDFDFD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_728_27625"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "matrix(-1 0 0 1 15.9999 0)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgComment, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Comment.c70a53e9.svg";
export { ForwardRef as ReactComponent };